module.exports = __webpack_public_path__ + "static/media/Ecrans bornes SDB V3-page-003.ce5ac86d.jpg";